import { Controller } from "@hotwired/stimulus";
import { track } from "../analytics";

export default class extends Controller {
  connect() {
    // Track pricing page view
    track("pricing_page_viewed");
  }

  trackPlanClick(event) {
    const planId = event.target.dataset.pricingPlanId;
    const planName = event.target.dataset.pricingPlanName;
    const price = event.target.dataset.pricingPrice;

    track("pricing_plan_clicked", {
      plan_id: planId,
      plan_name: planName,
      price: price,
    });
  }
}
